import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { PlanVamEntity } from '../../../vam/vam_entity';


declare var jQuery: any;

@Injectable()
export class CondicionesVamServices {
    private url = "vamTittular";

    constructor(private authHttp: AuthHttp) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaPlanesDetalleVam(poliza: PolizaEntity): Observable<PlanVamEntity[]>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarPlanesVam", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/condiciones/condiciones.service.ts